export default __webpack_public_path__ + "static/media/KZ.T.02.0575 black.411dffde.svg";